function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import cn from 'classnames';
import { capitalize } from 'lodash';
import _ from 'lodash/fp';
import filter from 'lodash/fp/filter';
import get from 'lodash/fp/get';
import orderBy from 'lodash/fp/orderBy';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import useEventListener from '../../hooks/useEventListener';
import { getAdminJobsList, getJobsList } from '../../redux/actions';
import { profileSelectors } from '../../redux/selectors/profile';
import text from '../../text';
import { isStaff } from '../../utilities/user';
import Loading from '../loading/Loading';
import { UNTITLED, statuses } from './consts';
import StatusFilterIcon from './filters/StatusFilterIcon';
import InviteRow from './inviteRow';
import OrderListingItem, { COLUMN } from './orderListingItem';
var NUM_SHOW_INITIAL = 20;
var NUM_SHOW_MORE = 10;
var isAscendingOrder = function(order) {
    return order && order === 'asc';
};
var Row = function(param) {
    var _param_data = param.data, item = _param_data.item, currentUser = _param_data.currentUser, isAdminOrigin = _param_data.isAdminOrigin, isStaff = _param_data.isStaff, index = param.index, style = param.style;
    // const item = useMemo(() => listItems[index], [listItems]);
    return item.type === 'invite' ? /*#__PURE__*/ React.createElement(InviteRow, {
        key: index,
        job: item.job,
        style: style
    }) : /*#__PURE__*/ React.createElement(OrderListingItem, {
        key: index,
        job: item.job,
        currentUser: currentUser,
        isAdminOrigin: isAdminOrigin,
        isStaff: isStaff,
        style: style
    });
};
export var ProjectListing = function(param) {
    var jobsList = param.jobsList, currentUser = param.currentUser, statusCounts = param.statusCounts, isAdminOrigin = param.isAdminOrigin, isStaff = param.isStaff, isLoading = param.isLoading, status = param.status, _param_searchText = param.searchText, searchText = _param_searchText === void 0 ? '' : _param_searchText;
    var _useState = _sliced_to_array(useState('updated_at'), 2), sortingProperty = _useState[0], setSortingProperty = _useState[1];
    var _useState1 = _sliced_to_array(useState('desc'), 2), sortOrder = _useState1[0], setSortOrder = _useState1[1];
    var _useState2 = _sliced_to_array(useState(jobsList), 2), orderedJobsList = _useState2[0], setOrderedJobsList = _useState2[1];
    var filterStatus = status.status;
    var _useState3 = _sliced_to_array(useState(NUM_SHOW_INITIAL), 2), showUpTo = _useState3[0], setShowUpTo = _useState3[1];
    var orderListingRef = useRef(null);
    var _useState4 = _sliced_to_array(useState(0), 2), height = _useState4[0], setHeight = _useState4[1];
    useEffect(function() {
        if (jobsList) {
            var sortedList = orderBy(sortingProperty === 'status' ? [
                function(job) {
                    return statuses[job.status].order;
                }
            ] : [
                get(sortingProperty)
            ], [
                sortOrder
            ], jobsList);
            var filteredList = filter(function(param) {
                var status = param.status, project = param.project, full_address = param.full_address;
                var filterByStatus = function(status) {
                    return filterStatus.includes(status);
                };
                var filterBySearchText = function(projectName, fullAddress) {
                    var searchByText = function(property) {
                        return property.toLowerCase().includes(searchText.toLowerCase());
                    };
                    if (searchText === '') return true;
                    if (projectName) return searchByText(projectName) || searchByText(fullAddress);
                    if (projectName === null) return searchByText(UNTITLED) || searchByText(fullAddress);
                    return false;
                };
                return filterByStatus(status) && filterBySearchText(project === null || project === void 0 ? void 0 : project.name, full_address);
            })(sortedList);
            setOrderedJobsList(filteredList);
        }
    }, [
        sortingProperty,
        sortOrder,
        jobsList,
        status
    ]);
    var handleSetSortingProperty = function(property) {
        setSortingProperty(property);
        setSortOrder(isAscendingOrder(sortOrder) ? 'desc' : 'asc');
    };
    var renderSortableHeading = function(header, propertyId, className) {
        return /*#__PURE__*/ React.createElement("th", {
            className: cn('column-header', _define_property({}, className, className)),
            onClick: function() {
                return handleSetSortingProperty(propertyId);
            }
        }, propertyId === 'status' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(StatusFilterIcon, {
            status: filterStatus
        }), /*#__PURE__*/ React.createElement("span", {
            className: "mx-4"
        }, header)) : header, /*#__PURE__*/ React.createElement("a", {
            className: "up-icon"
        }, sortingProperty === propertyId ? /*#__PURE__*/ React.createElement("img", {
            src: !isAscendingOrder(sortOrder) ? '/public/img/icon-up.svg' : '/public/img/icon-down.svg'
        }) : /*#__PURE__*/ React.createElement("div", null)));
    };
    var noOrdersAvailable = _to_consumable_array(filterStatus).map(function(status) {
        if (status === 'pending') return 'Quoted';
        if (status === 'inprogress') return 'Commenced';
        return capitalize(status);
    });
    var totalNumListItems = orderedJobsList === null || orderedJobsList === void 0 ? void 0 : orderedJobsList.length;
    var _useMemo = useMemo(function() {
        return orderedJobsList ? _.reduce(function(param, job) {
            var listItems = param.listItems, numListItems = param.numListItems;
            var _job_user_project;
            if (numListItems > showUpTo) {
                return {
                    listItems: listItems,
                    numListItems: numListItems
                };
            }
            listItems.push({
                type: 'job',
                job: job
            });
            if (((_job_user_project = job.user_project) === null || _job_user_project === void 0 ? void 0 : _job_user_project.invite_status) === 'pending') {
                listItems.push({
                    type: 'invite',
                    job: job
                });
            }
            numListItems++;
            return {
                listItems: listItems,
                numListItems: numListItems
            };
        }, {
            listItems: [],
            numListItems: 0
        }, orderedJobsList) : [];
    }, [
        orderedJobsList,
        showUpTo
    ]), listItems = _useMemo.listItems, numListItems = _useMemo.numListItems;
    var showMore = function() {
        setShowUpTo(function(prev) {
            return prev + NUM_SHOW_MORE;
        });
    };
    var getOrderListingContainerHeight = useCallback(function() {
        if (orderListingRef.current && listItems.length > 0) {
            setTimeout(function() {
                var _orderListingRef_current;
                return setHeight((_orderListingRef_current = orderListingRef.current) === null || _orderListingRef_current === void 0 ? void 0 : _orderListingRef_current.clientHeight);
            }, 300);
        }
    }, [
        listItems.length
    ]);
    useEventListener('resize', getOrderListingContainerHeight);
    useEffect(function() {
        getOrderListingContainerHeight();
    }, [
        getOrderListingContainerHeight
    ]);
    if (orderedJobsList === undefined) {
        return null;
    }
    return !isLoading ? /*#__PURE__*/ React.createElement("div", {
        id: "OrderListing",
        className: "overflow-hidden position-relative d-flex flex-column flex-fill",
        ref: orderListingRef
    }, listItems.length === 0 && /*#__PURE__*/ React.createElement("div", {
        className: "p-4 no-order-container"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-center mb-0"
    }, text('noOrdersAvailable', {
        status: /*#__PURE__*/ React.createElement("span", {
            className: "font-weight-bold"
        }, noOrdersAvailable.join(', '), ".")
    }))), listItems.length > 0 && /*#__PURE__*/ React.createElement(InfiniteScroll, {
        dataLength: listItems.length,
        next: showMore,
        hasMore: numListItems < totalNumListItems,
        loader: /*#__PURE__*/ React.createElement(Loading, null),
        scrollableTarget: "order-table"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "dashboard-table table-responsive",
        id: "order-table",
        style: _object_spread({}, height && {
            maxHeight: "".concat(height, "px")
        })
    }, /*#__PURE__*/ React.createElement("table", {
        className: "table"
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, renderSortableHeading(text('projectName'), 'project.name', COLUMN.NAME), renderSortableHeading(text('siteAddress'), 'full_address', COLUMN.ADDRESS), /*#__PURE__*/ React.createElement("th", {
        className: COLUMN.ORDER_COUNT
    }), renderSortableHeading(text('createdDate'), 'created_at', COLUMN.DATE), renderSortableHeading(text('updatedDate'), 'updated_at', COLUMN.DATE), renderSortableHeading(text('status'), 'status', COLUMN.STATUS), /*#__PURE__*/ React.createElement("th", {
        className: COLUMN.ACTIONS
    }, text('actions')))), /*#__PURE__*/ React.createElement("tbody", null, _.map(function(item) {
        return /*#__PURE__*/ React.createElement(Row, {
            key: item.job.id,
            data: {
                item: item,
                currentUser: currentUser,
                isAdminOrigin: isAdminOrigin,
                isStaff: isStaff
            }
        });
    }, listItems)))))) : /*#__PURE__*/ React.createElement(Loading, null);
};
export var useProjectListing = function() {
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var _useSelector = useSelector(function(state) {
        return {
            jobsList: state.jobsReducer.jobsList,
            statusCounts: state.jobsReducer.statusCounts,
            isJobsListLoading: state.jobsReducer.isJobsListLoading,
            adminJobList: state.jobsReducer.adminJobList,
            adminStatusCounts: state.jobsReducer.adminStatusCounts,
            isAdminJobListLoading: state.jobsReducer.isAdminJobListLoading,
            currentUser: state.profileReducer.userProfile,
            status: state.jobsReducer.listJobFilter,
            searchText: state.jobsReducer.listJobFilter.searchText
        };
    }), currentUser = _useSelector.currentUser, status = _useSelector.status, searchText = _useSelector.searchText, state = _object_without_properties(_useSelector, [
        "currentUser",
        "status",
        "searchText"
    ]);
    var listingParams = useMemo(function() {
        return isAdmin ? {
            isLoading: state.isAdminJobListLoading,
            jobsList: state.adminJobList,
            statusCounts: state.adminStatusCounts
        } : {
            isLoading: state.isJobsListLoading,
            jobsList: state.jobsList,
            statusCounts: state.statusCounts
        };
    }, [
        isAdmin,
        state
    ]);
    return _object_spread({
        isAdmin: isAdmin,
        currentUser: currentUser,
        status: status,
        searchText: searchText
    }, listingParams);
};
var ProjectListingWithRedux = function() {
    var dispatch = useDispatch();
    var _useProjectListing = useProjectListing(), isAdmin = _useProjectListing.isAdmin, currentUser = _useProjectListing.currentUser, status = _useProjectListing.status, searchText = _useProjectListing.searchText, isLoading = _useProjectListing.isLoading, jobsList = _useProjectListing.jobsList, statusCounts = _useProjectListing.statusCounts;
    // todo: only fetch once
    useEffect(function() {
        if (isAdmin) {
            dispatch(getAdminJobsList());
        } else {
            dispatch(getJobsList());
        }
    }, [
        isAdmin
    ]);
    return /*#__PURE__*/ React.createElement(ProjectListing, {
        currentUser: currentUser,
        isLoading: isLoading,
        isStaff: isStaff(currentUser === null || currentUser === void 0 ? void 0 : currentUser.role),
        jobsList: jobsList,
        statusCounts: statusCounts,
        status: status,
        searchText: searchText
    });
};
export default ProjectListingWithRedux;
